import { render } from "./expertDesc.vue?vue&type=template&id=cf802926&scoped=true"
import script from "./expertDesc.vue?vue&type=script&lang=js"
export * from "./expertDesc.vue?vue&type=script&lang=js"

import "./expertDesc.vue?vue&type=style&index=0&id=cf802926&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf802926"]])

export default __exports__